import { Badge, FlexLayout, H4 } from '@deity/falcon-ui';
import type { FC } from 'react';

interface ErrorNotificationProps {
  errorCount: number;
}
export const ErrorNotification: FC<ErrorNotificationProps> = ({ errorCount }) => (
  <FlexLayout alignItems="center" mt="xs">
    <FlexLayout
      alignItems="center"
      border="regular"
      borderRadius="small"
      pl="xs"
      pr="xs"
      bg={errorCount === 0 ? 'successLight' : 'errorLight'}
      borderColor={errorCount === 0 ? 'successDark' : 'errorDark'}
    >
      <Badge variant="round" bg="white" color={errorCount === 0 ? 'successDark' : 'errorTextDark'} ml="xs" mr="xs">
        {errorCount}
      </Badge>
      <H4 fontWeight="semiBold" fontSize="xs" color={errorCount === 0 ? 'successDark' : 'errorTextDark'}>
        ERROR{errorCount > 1 ? 'S' : ''}
      </H4>
    </FlexLayout>
  </FlexLayout>
);
